import { AddressList } from './AddressList';
import { GuideHelpText } from 'components/direct-sales/meterpoint-validation/components/GuideHelpText';
import { NsCard } from 'components/common/ns-card/NsCard';

export const testId = 'addressCardTestId';

type AddressCardProps = {
  addresses?: object;
  electricity?: boolean;
  gas?: boolean;
};

export const AddressCard = ({
  addresses = {},
  electricity = false,
  gas = false
}: AddressCardProps) => {
  const isDualValidation = electricity && gas;
  const anyAddress = Object.values(addresses).some((address) => !!address);

  if (!anyAddress) {
    return null;
  }

  return (
    <div data-testid={testId}>
      <NsCard heading="Your address">
        <AddressList addresses={addresses} hasTitle={isDualValidation} />
        <p>
          Incorrect address? <br />
          <GuideHelpText />
        </p>
      </NsCard>
    </div>
  );
};
